document.querySelectorAll('.product-group input[type="radio"]').forEach(function(radio) {
  radio.addEventListener('change', function() {
    if (this.checked) {
      const newImageSrc = this.dataset.image;
      // Cambia la imagen principal
      document.querySelector('.main-product-image').src = newImageSrc;
    }
  });
});
